import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '@features/auth/store/authStore';
import { hasPermission } from '@shared/auth/permissions';
import type { Permission } from '@shared/auth/permissions';
import { LoadingState } from '@shared/components/SystemStates';

export function AuthenticatedGuard() {
  const status = useAuthStore((state) => state.status);
  const setReturnTo = useAuthStore((state) => state.setReturnTo);
  const location = useLocation();
  useEffect(() => {
    if (status !== 'authenticated' && status !== 'loading') {
      setReturnTo(`${location.pathname}${location.search}`);
    }
  }, [location.pathname, location.search, setReturnTo, status]);

  if (status === 'loading') return <LoadingState />;
  if (status !== 'authenticated') {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
}

export function PublicOnlyGuard() {
  const status = useAuthStore((state) => state.status);
  if (status === 'loading') return <LoadingState />;
  return status === 'authenticated' ? <Navigate to="/dashboard" replace /> : <Outlet />;
}

export function PermissionGuard({ required }: { required: Permission }) {
  const granted = useAuthStore((state) => state.user?.permissions ?? []);
  return hasPermission(granted, required) ? <Outlet /> : <Navigate to="/access-denied" replace />;
}
